var React = require('react');

function ScalableSolution (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"#12EBAE","d":"M-439.4,268h-5.6l-0.1,0c0,0-0.1,0-0.1,0c-0.6-0.1-1-0.8-0.8-1.3c0.1-0.4,0.5-0.7,0.9-0.7h8c0,0,0,0,0.1,0\n\t\t\tc0,0,0.1,0,0.1,0c0.4,0.1,0.8,0.4,0.8,0.9c0,0,0,0.1,0,0.1v8c0,0.4-0.3,0.8-0.7,1c-0.6,0.2-1.2-0.3-1.3-0.8c0,0,0-0.1,0-0.1v-5.6\n\t\t\tl-16.6,16.6h5.6l0.1,0c0.6,0.1,1.1,0.8,0.9,1.4c-0.1,0.3-0.5,0.6-0.8,0.6c0,0-0.1,0-0.1,0h-8c0,0-0.1,0-0.1,0\n\t\t\tc-0.4,0-0.8-0.4-0.9-0.9c0,0,0-0.1,0-0.1v-8c0,0,0-0.1,0-0.1c0-0.4,0.4-0.8,0.9-0.9c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0\n\t\t\tc0.4,0.1,0.8,0.4,0.8,0.9c0,0,0,0.1,0,0.1v5.6L-439.4,268z"})));
}

ScalableSolution.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"-458 266 22 22","enableBackground":"new -458 266 22 22","xmlSpace":"preserve","height":"62px"};

module.exports = ScalableSolution;

ScalableSolution.default = ScalableSolution;
